<template>
  <!-- Dialog Cancel Account -->
  <ib-dialog
    :visible="visible"
    :show-close="false"
    width="480px"
    top="8vh"
    empty-header
    @close="closeDialog"
  >
    <!-- Dialog Content -->
    <ib-dialog-confirmation-content
      :image="require('@/assets/img/illustrations/cancel-subscription.svg')"
      :title="$t('cancelSubscriptionTitle')"
      :subtitle="message"
    />
    <!-- /Dialog Content -->

    <!-- Dialog Footer -->
    <template #footer>
      <ib-divider block class="mb-4" />
      <ib-dialog-footer
        button-size="sm"
        :submit-btn-text="$t('cancelSubscriptionButton')"
        :cancel-btn-text="$t('dialogs.remove.noJustKidding')"
        variant-button="red"
        outline-button
        :loading="loading"
        @cancel="closeDialog"
        @submit="cancelAccount"
      />
    </template>
    <!-- /Dialog Footer -->
  </ib-dialog>
  <!-- /Dialog Cancel Account -->
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import UserSubscriptionStatusEnum from '@/constants/UserSubscriptionStatusEnum'

export default {
  name: 'DialogCancelAccount',

  props: {
    visible: Boolean
  },

  data () {
    return {
      loading: false
    }
  },

  computed: {
    ...mapGetters('user', ['isFreeTrial']),

    message () {
      if (this.isFreeTrial) {
        return this.$t('cancelSubscriptionDescriptionFree')
      }

      return this.$t('cancelSubscriptionDescription')
    }
  },

  methods: {
    ...mapActions('user', ['updateUser']),
    ...mapMutations('user', ['setSubscriptionStatus']),

    closeDialog () {
      this.$emit('close')
    },

    cancelAccount () {
      const user = Object.assign({}, this.$store.state.user)
      user.status = 2
      this.loading = true
      this.updateUser(user)
        .then(_ => {
          this.setSubscriptionStatus(UserSubscriptionStatusEnum.DELETED)
          this.closeDialog()
          this.$intercom.trackEvent('Cancelled account')
          this.loading = false
        })
    }
  }
}
</script>
